"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "menu-item": "DefaultTheme__menu-item___19mOD",
  "icon": "DefaultTheme__icon___2Ae78",
  "disabled": "DefaultTheme__disabled___12XFE",
  "is-selected": "DefaultTheme__is-selected___t1jOA",
  "menuItem": "DefaultTheme__menu-item___19mOD",
  "isSelected": "DefaultTheme__is-selected___t1jOA"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "menu-item": "DarkTheme__menu-item___1Wxox",
  "menuItem": "DarkTheme__menu-item___1Wxox"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "menu-item": "LumeTheme__menu-item___3Lch9",
  "menuItem": "LumeTheme__menu-item___3Lch9"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_MenuItem["default"].displayName, themes.DefaultTheme)(_MenuItem["default"]);
ThemedComponent.displayName = _MenuItem["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map